module.exports = __webpack_public_path__ + "img/RA.ce49d99a.png";